// extracted by mini-css-extract-plugin
export var notificationHost = "_d3-0";